import { Component, OnInit, signal } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { CommonModule, NgIf, UpperCasePipe } from '@angular/common';
import { LoadingComponent } from '../../components/loading/loading.component';
import { NotFoundComponent } from '../../components/not-found/not-found.component';
import { Bind } from 'primeng/bind';
import { Divider } from 'primeng/divider';
import { OpeningHoursComponent } from '../../components/opening-hours/opening-hours.component';
import { Button } from 'primeng/button';
import { SafeStylePipe } from '../../pipes/safe-style.pipe';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { ApiService } from '../../_utils/api/api.service';
import { slugify } from '../../_utils/functions';
import { InsightService } from '../../_utils/insight/insight.service';
import { SeoService } from '../../_utils/seo/seo.service';

@Component({
    selector: 'app-location',
    templateUrl: './location.component.html',
    styleUrl: './location.component.scss',
    imports: [CommonModule, LoadingComponent, NotFoundComponent, TranslocoDirective, Bind, Divider, OpeningHoursComponent, Button, UpperCasePipe, SafeStylePipe, TranslatePipe]
})
export class LocationComponent implements OnInit {
  loading = signal(false);
  error: string = '';
  data: any = null;
  location: any = null;
  openingHours: any[] = [];

  constructor(private translocoService: TranslocoService, private seoService: SeoService, private titleService: Title, private metaTagService: Meta, private route: ActivatedRoute, protected router: Router, private apiService: ApiService, protected insightService: InsightService) { }

  ngOnInit(): void {
    this.loading.set(true);
    this.route.params.subscribe((params) => {
      this.translocoService.selectTranslate('main_location').subscribe((main_location) => {
        if (params['id']) {
          this.apiService.getCompany().subscribe({
            next: (data) => {
              this.loading.set(false);
              if (typeof window === 'undefined' && !parseInt(params['id'])) //check for other things
                return;

              if (params['id'] == 1 || (data.data.vanity_url && params['id'] == slugify(main_location))) {
                this.location = { ...data.data, id: 1, title: main_location };
              } else {
                this.location = (data.data.locations)?.find((location: any) => location.id == params['id']);

                if (!this.location && data.data.vanity_url) { //vanity url
                  this.location = (data.data.locations)?.find((location: any) => slugify(location.title) == params['id']);
                }

                if (!this.location) {
                  console.error('ID not found');
                }
              }

              if (this.location)
                this.openingHours = JSON.parse(this.location.openinghours);


              const translatePipe = new TranslatePipe(this.translocoService);
              let title = this.location?.title ? translatePipe.transform(this.location.title) : null;
              this.seoService.setSeo({
                title: title || data.data.denominazione,
                description: this.location?.address || data.data.description,
                image: this.location?.map || data.data.image || data.data.logo,
                url: data.data.pwa_url + '/sede/' + params['id']
              });

              if (typeof window === 'undefined')
                return;

              this.data = data.data;
              this.insightService.send({
                event: 'open_page',
                event_name: 'sede'
              });
            },
            error: (err) => {
              console.error(err);
              this.router.navigate(['error'], { queryParams: { message: err } });
            }
          });
        } else {
          console.error('Please provide a valid id');
        }
      });
    });
  }
}
